module.exports = __webpack_public_path__ + "media/images/athletes/3530-3fe0ce1f95f81fbbcce89a15ef188227.png";